import React, { useContext, useEffect, useRef, useState } from "react";
import { Image } from "react-bulma-components";
import { Link } from "react-router-dom";
import styled from "styled-components";
import StateContext from "../context/StateContext";
import { careDataUrl } from "./Utilities";
// import { DeltaFvAnimation } from "./FvAnimation";
// import { useFaceApi } from "react-use-faceapi";
import { Tween } from "react-gsap";
import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

gsap.registerPlugin(MotionPathPlugin);

const DateLinkContainer = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 256px;
`;

const DateClickContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 256px;
`;

const ResponsiveCalendarImage = styled.img`
  width: auto;
  height: auto;
  object-fit: cover;
  border: 4px inset black;
`;

function randomWalkArray(size) {
  const rw = [];
  for (let i = 0; i < size; i++) {
    rw.push({
      x: Math.random() < 0.5 ? 1 : -1,
      y: Math.random() < 0.5 ? 1 : -1,
    });
  }
  return rw;
}

function AnimatedIcon({ iconSrc, ...props }) {
  const randomWalk = randomWalkArray(200);
  return (
    <Tween
      to={{
        motionPath: {
          path: randomWalk,
          fromCurrent: true,
          relative: true,
        },
        duration: 100,
        repeat: 200,
        yoyo: true,
        ease: "power1.out",
      }}
    >
      <div>
        <Image src={iconSrc} size={24} alt="Icon"></Image>
      </div>
    </Tween>
  );
}

function UserImageDate({ link, src, alt, iconSrc, ...props }) {
  const [, dispatch] = useContext(StateContext);
  const imageRef = useRef();

  return (
    <DateClickContainer
      onClick={() => {
        dispatch({ type: "captureNewImage" });
      }}
    >
      <ResponsiveCalendarImage
        id="camera-img"
        ref={imageRef}
        src={src}
        alt={alt}
      ></ResponsiveCalendarImage>

      <Image src={iconSrc} size={24} alt="Icon"></Image>
    </DateClickContainer>
  );
}

function CalendarDate({ link, src, alt, iconSrc, ...props }) {
  const [state] = useContext(StateContext);

  return (
    <DateLinkContainer to={link}>
      <ResponsiveCalendarImage src={src} alt={alt}></ResponsiveCalendarImage>
      {state.numPagesVisited > 3 ? (
        <AnimatedIcon iconSrc={iconSrc} size={24} alt="Icon"></AnimatedIcon>
      ) : (
        <Image src={iconSrc} size={24} alt="Icon"></Image>
      )}
    </DateLinkContainer>
  );
}

const CalendarContainer = styled.div`
  background-color: ${(props) => props.theme.componentBackground};
  border: inset 0.7em ${(props) => props.theme.accentLight};
  display: grid;
  grid-template-columns: repeat(4, minmax(64px, 256px));
  gap: 10px;
  padding: 10px;
  justify-items: center;
  align-items: center;
`;

// const useCanvas = (draw) => {
//   const canvasRef = useRef(null);

//   useEffect(() => {
//     const canvas = canvasRef.current;
//     const context = canvas.getContext("2d");

//     const render = () => {
//       draw(context);
//     };
//     render();
//   }, [draw]);

//   return canvasRef;
// };

function SeptemberDate({ dataItem, inverted, ...props }) {
  const [state] = useContext(StateContext);

  return (
    <UserImageDate
      key={dataItem.index}
      inverted={inverted}
      recognizeFaces={true}
      src={
        state.userImage &&
        state.userImage.length > 0 &&
        state.numPagesVisited > 2
          ? state.userImage
          : careDataUrl(dataItem.cover, dataItem.index)
      }
      alt={dataItem.index}
      iconSrc={careDataUrl(dataItem.icon, dataItem.index)}
    ></UserImageDate>
  );
}

function Calendar({ data, ...props }) {
  return (
    <CalendarContainer>
      {data.map((dataItem, index) =>
        dataItem.index === "9" ? (
          <SeptemberDate
            key={dataItem.index}
            dataItem={dataItem}
          ></SeptemberDate>
        ) : (
          <CalendarDate
            key={dataItem.index}
            link={"/" + dataItem.index}
            src={careDataUrl(dataItem.cover, dataItem.index)}
            alt={dataItem.index}
            iconSrc={careDataUrl(dataItem.icon, dataItem.index)}
          ></CalendarDate>
        )
      )}
    </CalendarContainer>
  );
}

export default Calendar;

/*


const figureEightAnimationX = keyframes`
50% {
  animation-timing-function: ease-in;
  transform: translateX(100px);
}
`;

const figureEightAnimationY = keyframes`
50% {
  animation-timing-function: ease-out;
  transform: translateY(100px);
}
`;

const FigureEightIcon = styled(Image)`
  &::before {
    animation: ${figureEightAnimationY} 4s ease-out infinite;
    content: "";
  }
`;

const UpDownDiv = styled.div`
  animation: ${figureEightAnimationY} ${(props) => props.time || "2s"}
    ${(props) => props.easing || "ease-out"} ${(props) => props.delay || "0s"}
    ${(props) => props.iterationCount || "infinite"}
    ${(props) => props.direction || "normal"};
`;
const LeftRightDiv = styled.div`
  animation: ${figureEightAnimationX} ${(props) => props.time || "2s"}
    ${(props) => props.easing || "ease-in"} ${(props) => props.delay || "0s"}
    ${(props) => props.iterationCount || "infinite"}
    ${(props) => props.direction || "normal"};
`;

const AnimatedDiv = styled.div`
  animation: ${(props) => props.animation} ${(props) => props.time || "2s"}
    ${(props) => props.easing || "ease-in"} ${(props) => props.delay || "0s"}
    ${(props) => props.iterationCount || "infinite"}
    ${(props) => props.direction || "normal"};
`;

function FigureEight({
  children,
  timeY,
  timeX,
  easingY,
  easingX,
  delayY,
  delayX,
  iterationCountY,
  iterationCountX,
  directionY,
  directionX,
  ...props
}) {
  return (
    <UpDownDiv
      time={timeY}
      easing={easingY}
      delay={delayY}
      iterationCount={iterationCountY}
      direction={directionY}
    >
      <LeftRightDiv
        time={timeX}
        easing={easingX}
        delay={delayX}
        iterationCount={iterationCountX}
        direction={directionX}
      >
        {children}
      </LeftRightDiv>
    </UpDownDiv>
  );
}

function randomSeconds(max, min = 0) {
  return "" + Math.floor(Math.random() * max) + "s";
}


// Face API
const faceApiConfig = {
  input: "camera-img",
  refreshRate: 250,
};

  const faces = useFaceApi(faceApiConfig);
      {faces &&
        faces.map((face, index) => {
          const top = face.relativeBox.top * imageRef.current.offsetHeight;
          const left = face.relativeBox.left * imageRef.current.offsetWidth;
          const width = face.relativeBox.width * imageRef.current.offsetWidth;
          const height =
            face.relativeBox.height * imageRef.current.offsetHeight;
          return (
            <div
              key={index}
              style={{
                position: "absolute",
                width: width,
                height: height,
                left: left,
                top: top,
                border: "1px solid red",
              }}
            />
          );
        })}

// useEffect(() => {
//   if (imgRef && processedImage && processedImage.length > 0) {
//     const image = cv.imread(imgRef.current);
//     var dst = new cv.Mat();
//     let rect = new cv.Rect(100, 100, 228, 228);
//     dst = image.roi(rect);
//     cv.imshow(outputRef.current, dst);
//   }
// }, [processedImage, imgRef, outputRef, setProcessedImage]);

*/
